module.exports = "/_next/static/images/64a937530667be86c787ecf08eeb3820-hero.jpg";